export const isIos = () => {
    console.log('testing isIos...', navigator.userAgent, /iPad|iPhone|iPod/.test(navigator.userAgent));
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
};
